import { isNil } from 'lodash';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { REQUIRED_ERROR_MESSAGE } from 'modules/common/constants';
import { useRefCallback } from '../util';

const useStyles = makeStyles((theme) => ({
  readOnlySelect: {
    cursor: 'auto',
  },
  readOnlySelectIcon: {
    display: 'none',
  },
}));

const TRCInputValidator = (props) => {
  const { component: Component, onBlur, validateOnBlur, validateOnChange, onChange, value, required, ...rest } = props;
  const [ref, setRef] = useRefCallback();
  const classes = useStyles();

  const handleBlur = useCallback(() => {
    if (rest.InputProps.readOnly) {
      return;
    }
    let newVal = value;
    if (typeof newVal === 'string') {
      newVal = newVal.trim();
    }
    if (ref && validateOnBlur) {
      ref.validate(newVal, true);
    }
    onBlur(newVal);
    onChange(newVal);
  }, [ref, onBlur, onChange, validateOnBlur, value, rest.InputProps]);

  const handleChange = useCallback((val) => {
    if (rest.InputProps.readOnly) {
      return;
    }
    const newVal = (val && val.target) ? val.target.value : val;
    if (ref && validateOnChange) {
      ref.validate(newVal, true);
    }
    onChange(newVal);
  }, [ref, validateOnChange, onChange, rest.InputProps]);

  return (
    <Component
      ref={setRef}
      value={!isNil(value) ? value : ''}
      variant="outlined"
      onBlur={handleBlur}
      onChange={handleChange}
      required={required}
      validators={required ? ['required'] : []}
      errorMessages={required ? [REQUIRED_ERROR_MESSAGE] : []}
      SelectProps={rest.InputProps.readOnly ? { classes: { select: classes.readOnlySelect, icon: classes.readOnlySelectIcon } } : {}}
      {...rest}
    />
  );
};

TRCInputValidator.defaultProps = {
  value: '',
  InputProps: {},
  onBlur: () => {},
  onChange: () => {},
  required: false,
  validateOnBlur: true,
  validateOnChange: false,
};

TRCInputValidator.propTypes = {
  component: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
};

export default TRCInputValidator;
